import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = {
  key: 0,
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0" }
const _hoisted_19 = {
  class: "dropdown-menu dropdown-block",
  style: {"position":"absolute","inset":"0px auto auto 0px","margin":"0px","transform":"translate(267px, 305px)"},
  "data-popper-placement": "bottom-start"
}
const _hoisted_20 = {
  key: 0,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_23 = {
  key: 2,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 3,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_28 = {
  key: 4,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_EditUserPassModal = _resolveComponent("EditUserPassModal")!
  const _component_AddRoleModal = _resolveComponent("AddRoleModal")!
  const _component_AddPointVenteModal = _resolveComponent("AddPointVenteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h3", { class: "text-black fw-semibold" }, "Liste des utilisateurs")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.checkPermission('AddUser'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                class: "btn btn-primary text-black",
                to: "/utilisateurs/ajouter-utilisateur"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                  _createTextVNode(" Ajouter un utilisateur ")
                ])),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "search-bg svg-color pt-3",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black",
              placeholder: "Rechercher un utilisateur"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-black transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.users.length > 0)
            ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Nom et Prénom "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Téléphone "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Email "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Rôle "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Sexe "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Statut "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
                    }, "Date création"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
                    }, "Actions")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("th", _hoisted_8, _toDisplayString(user.nom) + " " + _toDisplayString(user.prenom), 1),
                      _createElementVNode("td", _hoisted_9, _toDisplayString(user.telephone), 1),
                      _createElementVNode("td", _hoisted_10, _toDisplayString(user.email), 1),
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.userRoles, (userRole, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: index,
                              class: "text-center"
                            }, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  (userRole.role)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(userRole.role.nom), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(user.sexe), 1),
                      _cache[13] || (_cache[13] = _createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                        _createElementVNode("span", { class: "badge badge-primary background-light-primary font-primary" }, "Actif")
                      ], -1)),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.format_date(user.createdAt)), 1),
                      _createElementVNode("td", _hoisted_18, [
                        _cache[12] || (_cache[12] = _createElementVNode("button", {
                          class: "btn dropdown-toggle btn-primary text-black",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, "Actions", -1)),
                        _createElementVNode("ul", _hoisted_19, [
                          (_ctx.checkPermission('EditPassword'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: "text-black",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#EditUserPassModal",
                                  onClick: ($event: any) => (_ctx.openEditPassModal(user))
                                }, _cache[6] || (_cache[6] = [
                                  _createElementVNode("i", { class: "fa fa-lock lh-2 me-8 position-relative top-1 text-black" }, null, -1),
                                  _createTextVNode(" Modifier le mot de passe ")
                                ]), 8, _hoisted_21)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.checkPermission('EditUser'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                                _createVNode(_component_router_link, {
                                  to: { name: 'EditUser',params: { id: user.id } },
                                  class: "text-black"
                                }, {
                                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                                    _createElementVNode("i", { class: "fa fa-pencil lh-2 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Voir ou Modifier les informations ")
                                  ])),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.checkPermission('AddUserRole'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: "text-black",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#AddRoleModal",
                                  onClick: ($event: any) => (_ctx.openAddPointVenteModal(user))
                                }, _cache[8] || (_cache[8] = [
                                  _createElementVNode("i", { class: "fa fa-lock lh-2 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Ajouter un rôle ")
                                ]), 8, _hoisted_24)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.checkPermission('AddUserRole'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: "text-black",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#AddPointVenteModal",
                                  onClick: ($event: any) => (_ctx.openAddRoleModal(user))
                                }, _cache[9] || (_cache[9] = [
                                  _createElementVNode("i", { class: "fa fa-lock lh-2 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Ajouter un point de vente ")
                                ]), 8, _hoisted_26)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", _hoisted_27, [
                            _createVNode(_component_router_link, {
                              to: { name: 'ViewUser', params: { id: user.id } },
                              class: "dropdown-item d-flex align-items-center text-black"
                            }, {
                              default: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createElementVNode("i", { class: "fa fa-eye lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode("Détails ")
                              ])),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          (_ctx.checkPermission('DeleteUserRole'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                _createElementVNode("a", {
                                  href: "javascript:void(0);",
                                  class: "text-black",
                                  onClick: ($event: any) => (_ctx.suppression(user.id, _ctx.users, 'users', 'un utilisateur'))
                                }, _cache[11] || (_cache[11] = [
                                  _createElementVNode("i", { class: "fa fa-trash-o lh-2 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Supprimer ")
                                ]), 8, _hoisted_29)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_EditUserPassModal, { selectedUser: _ctx.selectedUser }, null, 8, ["selectedUser"]),
    _createVNode(_component_AddRoleModal, {
      selectedUser: _ctx.selectedUser,
      onClose: _ctx.rechercher
    }, null, 8, ["selectedUser", "onClose"]),
    _createVNode(_component_AddPointVenteModal, {
      selectedUser: _ctx.selectedUser,
      selectedUserId: _ctx.selectedUserId
    }, null, 8, ["selectedUser", "selectedUserId"])
  ], 64))
}